export default __webpack_public_path__ + "static/media/Thug's Belt of the Battlethrall.a13abab7.jpg";